import React from "react";
import { CircleAlert } from "lucide-react";
import Tooltip from "components/ui/Tooltip";
import ActiveBadge from "../../../components/ActiveBadge";
import Chip from "../../../components/Chip";
import LifecycleBadge from "../../../components/LifecycleBadge";
import { TRIGGER_TYPES } from "../features/trigger.constants";

function TypeCell({ type }) {
  const meta = TRIGGER_TYPES.find((t) => t.value === type);
  if (!meta) return <span className="text-xs text-text_muted">{type}</span>;
  const Icon = meta.icon;
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-text_secondary">
      <Icon size={13} className="text-primary" /> {meta.label}
    </span>
  );
}

function LifecycleCell({ row }) {
  return (
    <div className="flex items-center gap-1.5">
      <LifecycleBadge status={row.status} version={row.version_no} />
      {row.validation_message && (
        <Tooltip content={<span className="whitespace-pre-wrap">{row.validation_message}</span>}>
          <span tabIndex={0} aria-label="Publish problems" className="cursor-help">
            <CircleAlert size={14} className={row.status === "ACTIVE" ? "text-warning" : "text-danger"} />
          </span>
        </Tooltip>
      )}
    </div>
  );
}

// Columns of the Trigger list. `start` is the row number offset of the current page.
export const getTriggerColumns = (start) => [
  { key: "id", label: "S.No", width: "70px", sortable: false, render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span> },
  {
    key: "name",
    label: "Trigger",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-medium text-text_primary">{row.name}</span>
        <span className="truncate font-mono text-[11px] text-text_muted">{row.code}</span>
      </div>
    ),
  },
  { key: "trigger_type", label: "Type", sortable: true, render: (row) => <TypeCell type={row.trigger_type} /> },
  {
    key: "source_fid",
    label: "Source",
    sortable: true,
    render: (row) => (row.source ? <span className="text-xs text-text_secondary">{row.source.label}</span> : <span className="text-xs text-text_muted">No source</span>),
  },
  { key: "module", label: "Module", sortable: false, render: (row) => <span className="text-xs text-text_secondary">{row.module?.label ?? "—"}</span> },
  { key: "status", label: "Lifecycle", sortable: true, render: (row) => <LifecycleCell row={row} /> },
  {
    key: "rule_count",
    label: "Used",
    sortable: false,
    render: (row) => (
      <div className="flex flex-wrap gap-1">
        <Chip>{row.rule_count ?? 0} rules</Chip>
        <Chip>{row.template_count ?? 0} templates</Chip>
      </div>
    ),
  },
  { key: "is_activated", label: "Status", sortable: true, render: (row) => <ActiveBadge active={row.is_activated} /> },
];
